export default __webpack_public_path__ + "static/media/noreference.42c115d9.svg";